import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStoryFeatured = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1200pt",
	height: "1200pt",
	viewBox: "0 0 1200 1200",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m747.6 680.4 43.199 212.4-190.8-106.8-190.8 106.8 43.199-212.4-160.8-146.4 217.2-25.199 91.199-195.6 91.199 196.8 217.2 25.199z",
		fill: "#474747"
	})
});
export default SvgStoryFeatured;
